"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import Link from "next/link";
import { FileQuestion } from "lucide-react";

/**
 * Global 404 page — rendered when no route matches.
 * Adds a Sentry breadcrumb so we can track how users land on missing pages.
 */
export default function NotFound() {
  useEffect(() => {
    Sentry.addBreadcrumb({
      category: "navigation",
      message: `404: ${window.location.pathname}`,
      data: {
        path: window.location.pathname,
        referrer: document.referrer || "direct",
      },
      level: "info",
    });
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="max-w-md text-center space-y-6 p-8">
        <FileQuestion className="mx-auto h-16 w-16 text-muted-foreground" />
        <div className="space-y-2">
          <h1 className="text-4xl font-bold">Page not found</h1>
          <p className="text-muted-foreground">
            The page you&apos;re looking for doesn&apos;t exist or has been
            moved.
          </p>
        </div>
        <Link
          href="/dashboard"
          className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
        >
          Go to dashboard
        </Link>
      </div>
    </div>
  );
}